import { pushToDataLayer } from '@domain-group/fe-helper';

export default pushToDataLayer;
